import { queryApi } from "src/utils/api/ApiMethods"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const getNightDatatable = (night, params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const queryParams = new URLSearchParams({
    ...params,
    ...(params.page && { page: params.page }),
    ...(params.arrival && { arrival: params.arrival }),
    ...(params.departure && { departure: params.departure }),
    ...(params.booking_type && { booking_type: params.booking_type }),
    ...(params.sort && { sort: params.sort }),
    ...(params.direction && { direction: params.direction }),
    ...(params.all && { all: params.all }),
  }).toString()

  const url = `/manage/${marinaSlug}/reservations/night_datatable/${night}${
    queryParams ? `?${queryParams}` : ""
  }`
  return queryApi(url)
}

export const getSpaceAssignments = (reservationId) => {
  const marinaSlug = getCurrentMarinaSlug()
  return queryApi(
    `/manage/${marinaSlug}/reservations/${reservationId}/space_assignments`
  )
}
